export const ENDPOINTS_USERAPP = {
  GET_ALL: "/userapps",
  GET_BY_ID: (id: number) => `/userapps/${id}`,
  POST: "/userapps",
  PUT: (id: number) => `/userapps/${id}`,
  DELETE: (id: number) => `/userapps/${id}`,
  ACTIVATE: (id: number) => `/userapps/${id}/activate`,
  DEACTIVATE: (id: number) => `/userapps/${id}/deactivate`,
  GENERATE_LOGIN: `/userapps/login`,
  GET_ORGANIZATION_BY_USER_ID: (id: number) => `/userapps/${id}/organization`,
  // Metadata
  PUT_METADATA: (id: number) => `/userapps/${id}/metadata`,
  GET_METADATA: (id: number) => `/userapps/${id}/metadata`,

  GET_ALL_AFFECTED_DETAILS: "/users_details",
  GET_USER_DETAILS: (id: number) => `/users_details/${id}`,
  GET_ALL_BY_TYPE: (typeRelationId: number, typeUserParentId: number) =>
    `/users_details/search/${typeRelationId}/${typeUserParentId}`,

  POST_SAVE_DETAILS: "/users_details/save",
};

export const ENDPOINTS_PASSWORDS = {
  GET_BY_IDUSERAPP: (id: number) => `/passwords/user/${id}`,
  POST: "/passwords",
  PUT: "/passwords",
  DELETE: (id: number) => `/passwords/${id}`,
};

export const ENDPOINTS_USERAPP_LOGS = {
  GET_BY_USER: (id: number) => `/userapp-logs/by-user/${id}`,
};

export const ENDPOINTS_PROGRESS = {
  GET_BY_IDCOURSE: (course_id: number) =>
    `/api/lesson-progress/course/${course_id}`, // user ID is in token data
  GET_BY_IDLESSON: (lesson_id: number) =>
    `/api/lesson-progress/lesson/${lesson_id}`,
  POST_SAVE: (lesson_id: number) => `/api/lesson-progress/${lesson_id}`,

  GET_PROGRESS_BY_IDCOURSE: (course_id: number) =>
    `/api/lesson-progress/progress/course/${course_id}`, // user ID is in token data
  GET_PROGRESS_BY_IDSUBJECT: (subject_id: number) =>
    `/api/lesson-progress/progress/subject/${subject_id}`, // user ID is in token data
};

export const ENDPOINTS_USER_ANSWERS = {
  GET_BY_QUESTION_ID: (question_id: number) =>
    `/api/lesson-answer-user/question/${question_id}`, // user ID is in token data
  POST_SAVE: `/api/lesson-answer-user/`,
};

export const ENDPOINTS_ROLES = {
  GET_ALL: `/roles`,

  GEL_ALL_LINKED_ROLES: `/role_usertypes`,
  POST_ROLE_TO_TYPE_USER: `/role_usertypes`,
  DELETE_ROLE_TO_TYPE_USER: (id: number) => `/role_usertypes/${id}`,
};

// ===================================================
//  DASHBOARD
// ===================================================
export const ENDPOINTS_DASHBOARD = {
  GET_DASHBOARD: "/api/dashboard",
};


export const ENDPOINTS_CODE_ANSWERS = {
  GET_BY_USER: `/api/user-answer/user`,
  GET_BY_LESSON: (lesson_id: number) =>
    `/api/user-answer/lesson/${lesson_id}`,
  POST_SAVE: (lesson_id: number) =>
    `/api/user-answer/lesson/${lesson_id}`,
};



export const ENDPOINTS_COMMENTS = {
  GET_ALL: "/api/comments", // GET /comments
  GET_BY_ID: (id: number) => `/api/comments/${id}`, // GET /comments/:id
  POST: "/api/comments", // POST /comments
  PUT: (id: number) => `/api/comments/${id}`, // PUT /comments/:id
  DELETE: (id: number) => `/api/comments/${id}`, // DELETE /comments/:id
  GET_BY_USERAPP_ID: () => `/api/comments/user`, // GET /comments/user/:userapp_id
  GET_BY_PROJECT_ID: (projectId: number) => `/api/comments/project/${projectId}`, // GET /comments/project/:project_id
};
